export default "__VITE_ASSET__a2a90736__"